export default __webpack_public_path__ + "static/media/palindrome.a8056c38.png";